$(document).ready(function() {
	
	/*================ UI ================*/
	$( function() {
		$( ".ui-tabs" ).tabs({
			heightStyle: "content",
			load: clickToOpenTab()
		});
		
		function clickToOpenTab() {
			$('.open-tab').click(function (event) {
				event.preventDefault();
				var tab = $(this).attr('data-tab');
				var tab_index = $('.ui-tabs-panel').index( $(tab) );
				$('html, body').animate({
					scrollTop: $('.ui-tabs').offset().top
				}, 1000);
				$('.ui-tabs').tabs('option', 'active', tab_index);
	    });
		}
		
		$( ".ui-accordion" ).accordion({
			collapsible: true
		});
		
		$( ".ui-accordion-collapsed" ).accordion({
			active: false,
			collapsible: true
		});
		
		$('.slick-carousel').slick({
		  slidesToShow: 4,
			responsive: [
				{
				  breakpoint: 480,
				  settings: {
				    slidesToShow: 2
				  }
				}
			]
		});
		
	});
	
	/*====== Accessibility: Menu Dropdowns =======*/
	$('.site-nav--has-dropdown > a.site-nav__link').focus(function() {
		$(this).next('.site-nav__dropdown').addClass('open');
		$(this).attr('aria-expanded', true);
	});
	
	$(document).on('focusout', '.site-nav__dropdown ul:not(.site-nav__childlist-grid, .site-nav__grandchildlist):last-of-type li:last-of-type a, .site-nav__dropdown ul.site-nav__childlist-grid:last-of-type li.site-nav__childlist-item:last-of-type ul li:last-of-type a', function() {
	  $(this).closest('.site-nav__dropdown').removeClass('open');
		$(this).closest('.site-nav__dropdown').prev('site-nav__link').attr('aria-expanded', false);
	});
	
	$('.site-nav--has-dropdown').hover(function() {
		$(this).children('a.site-nav__link').attr('aria-expanded', true);
	}, function() {
		$(this).children('a.site-nav__link').attr('aria-expanded', false);
	});

});

/* Smooth Scroll On Anchors */
$(function() {
  $('a[href*="#"]:not([href="#"]):not(.noscroll)').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 1000);
        return false;
      }
    }
  });
});

/* Free Shipping Bar */
function animateFreeShippingThreshold() {
	var threshold = $('.free_shipping_progress_bar').attr('data-threshold');
	var total = $('.free_shipping_progress_bar').attr('data-total');
	var percentage = total / threshold * 100;
	if ( percentage > 100 ) percentage = 100;
	if ( percentage >= 100 ) {
		$('.free_shipping_progress .status').hide();
		$('.free_shipping_progress .qualified').show();
	} else {
		$('.free_shipping_progress .status').show();
		$('.free_shipping_progress .qualified').hide();
	}
	$('.free_shipping_progress_bar .progress').animate({ width: percentage + '%' }, 1000, function() {
		if ( percentage >= 100 ) $('.free_shipping_progress').addClass('threshold_reached');
	});
}
function recalculateShippingThreshold(new_total) {
	var threshold = $('.free_shipping_progress .free_shipping_progress_bar').attr('data-threshold');
	var new_threshold_diff = threshold - new_total;
	$('.free_shipping_progress_bar').attr('data-total', new_total);
	$('.free_shipping_progress .status .money').text('$' + (new_threshold_diff/100).toFixed( 2 ).replace('.00', '') );
	if ( new_threshold_diff > 0 ) {
		$('.free_shipping_progress .status').show();
		$('.free_shipping_progress .qualified').hide();
	} else {
		$('.free_shipping_progress .status').hide();
		$('.free_shipping_progress .qualified').show();
	}
	animateFreeShippingThreshold();
}